import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import {
  TellentNavigationHttpContract,
  TellentNavigationViewID,
  TellentNavigationScope,
} from '@core/tellent-types';

import { patchMainNavContract, patchSettingsNavContract } from './temp-contract-align';

@Injectable({ providedIn: 'root' })
export class TellentNavigationHttpClient {
  #http = inject(TellentHttpApiService);

  public fetchMainNav(
    navigationScope: TellentNavigationScope[],
  ): Observable<TellentNavigationHttpContract[]> {
    return this.#http
      .get<{
        data: TellentNavigationHttpContract;
      }>('/ui/navigation/main', { app_kinds: navigationScope })
      .pipe(
        map(({ data }) => [
          {
            ...patchMainNavContract(data),
            id: TellentNavigationViewID.Main,
          },
        ]),
      );
  }

  public fetchSettingsNav(
    navigationScope: TellentNavigationScope[],
  ): Observable<TellentNavigationHttpContract[]> {
    return this.#http
      .get<{
        data: TellentNavigationHttpContract;
      }>('/ui/navigation/settings', { app_kinds: navigationScope })
      .pipe(
        map(({ data }) => [
          {
            ...patchSettingsNavContract(data),
            id: TellentNavigationViewID.Settings,
          },
        ]),
      );
  }
}
